import {SubscriptionOptionInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';
import {SubscriptionSettingsModel} from './SubscriptionSettings.model';

export class SubscriptionInfoModel {
  public title: string;
  public subscriptionSettings: SubscriptionSettingsModel;

  constructor(params: SubscriptionInfoModel) {
    this.title = params.title;
    this.subscriptionSettings = params.subscriptionSettings;
  }

  public static fromCartV1(subscriptionInfo?: SubscriptionOptionInfo | null) {
    if (!subscriptionInfo) {
      return undefined;
    }
    return new SubscriptionInfoModel({
      title: subscriptionInfo.title?.translated ?? subscriptionInfo.title?.original ?? '',
      subscriptionSettings: SubscriptionSettingsModel.fromCartV1(subscriptionInfo.subscriptionSettings),
    });
  }

  public static fromCartV2(subscriptionInfo: SubscriptionOptionInfo): SubscriptionInfoModel {
    if (!subscriptionInfo) {
      return undefined;
    }
    return new SubscriptionInfoModel({
      title: subscriptionInfo.title?.translated ?? subscriptionInfo.title?.original ?? '',
      subscriptionSettings: SubscriptionSettingsModel.fromCartV2(subscriptionInfo.subscriptionSettings),
    });
  }
}
